module.exports = __webpack_public_path__ + "static/media/Inter3.48caaa9b.png";